import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, FlexBox } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { change, Field } from 'redux-form';
import { messengerSettingsFormFields, } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';
import { messengerAppearanceFormName } from '../../../messengerSettingsFormValueSelector';
import { FormSectionTitle } from '../../formSectionTitle';
import { ColorInputField } from '../components/ColorInputField';
import { ColorOptions } from './components/colorOptions/ColorOptions';
const bgColorFieldName = messengerSettingsFormFields.backgroundColor;
export const MessengerTheme = ({ presetBackgrounds, backgroundColor, }) => {
    const dispatch = useDispatch();
    function isPresetColor(color) {
        return presetBackgrounds.map(({ id }) => id).includes(color);
    }
    function resolveColor(themeIdOrCustomColor) {
        var _a, _b;
        if (isPresetColor(themeIdOrCustomColor)) {
            return ((_b = (_a = presetBackgrounds.find(({ id }) => id === themeIdOrCustomColor)) === null || _a === void 0 ? void 0 : _a.background) !== null && _b !== void 0 ? _b : themeIdOrCustomColor);
        }
        return themeIdOrCustomColor;
    }
    const initialMode = isPresetColor(backgroundColor)
        ? 'preset'
        : 'custom';
    const presetColorCodes = presetBackgrounds
        .map(({ background }) => background)
        .filter(Boolean);
    const [mode, setMode] = useState(initialMode);
    function setBgColorFieldValue(value) {
        dispatch(change(messengerAppearanceFormName, bgColorFieldName, value));
    }
    function toggleMode() {
        switch (mode) {
            case 'preset':
                setMode('custom');
                // switching to custom mode, so convert color id to actual color
                setBgColorFieldValue(resolveColor(backgroundColor));
                break;
            case 'custom':
                setMode('preset');
                // switching to preset mode, so set it to default preset
                setBgColorFieldValue('midnight');
                break;
        }
    }
    return (_jsxs(FlexBox, Object.assign({ gap: "300", width: "500px", flexDirection: "column", alignItems: "flex-start" }, { children: [_jsx(FormSectionTitle, { title: "Background color", description: "Select a theme color" }), _jsx(Field, { required: true, name: bgColorFieldName, component: ColorOptions, options: presetBackgrounds }), mode === 'custom' && (_jsx(Field, { required: true, noLabel: true, clearable: false, name: bgColorFieldName, component: ColorInputField, presetColors: presetColorCodes })), mode === 'preset' && (_jsx(Button, Object.assign({ variant: "tertiary", onClick: toggleMode, style: { marginLeft: -12 } }, { children: "Or create a custom color" })))] })));
};
